import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Check, Send, Upload } from "lucide-react";
import { REQUIREMENT_OPTIONS } from "../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function EnquiryForm({ defaultRequirement = "", product = "" }) {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData(e.currentTarget);
    try {
      const res = await axios.post(`${API}/enquiries`, data);
      if (res.data.status === "ok") {
        setSent(true);
        toast.success("Enquiry sent — our team will contact you shortly.");
      } else {
        toast.error(res.data.detail || "Please check the form and try again.");
      }
    } catch {
      toast.error("Something went wrong. Please call or WhatsApp us directly.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="enquiry-form form-success" data-testid="enquiry-success">
        <div className="ok-icon"><Check size={26} /></div>
        <h3>Enquiry received.</h3>
        <p>Thank you — your requirement is with our team. We usually respond within one business day. For anything urgent, call or WhatsApp us.</p>
      </div>
    );
  }

  return (
    <form className="enquiry-form" onSubmit={submit} data-testid="enquiry-form">
      <div className="form-grid">
        <div className="form-field">
          <label htmlFor="f-name">Name <b>*</b></label>
          <input id="f-name" name="name" required placeholder="Your name" data-testid="enquiry-name" />
        </div>
        <div className="form-field">
          <label htmlFor="f-company">Company Name</label>
          <input id="f-company" name="company" placeholder="Company name" data-testid="enquiry-company" />
        </div>
        <div className="form-field">
          <label htmlFor="f-mobile">Mobile Number <b>*</b></label>
          <input id="f-mobile" name="mobile" required type="tel" placeholder="Best number to reach you" data-testid="enquiry-mobile" />
        </div>
        <div className="form-field">
          <label htmlFor="f-email">Email</label>
          <input id="f-email" name="email" type="email" placeholder="you@company.com" data-testid="enquiry-email" />
        </div>
        <div className="form-field">
          <label htmlFor="f-city">City / Location <b>*</b></label>
          <input id="f-city" name="city" required placeholder="Where is the site?" data-testid="enquiry-city" />
        </div>
        <div className="form-field">
          <label htmlFor="f-req">Requirement <b>*</b></label>
          <select id="f-req" name="requirement" required defaultValue={defaultRequirement} data-testid="enquiry-requirement">
            <option value="" disabled>Select your requirement</option>
            {REQUIREMENT_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        </div>
        <div className="form-field full">
          <label htmlFor="f-size">Warehouse Size</label>
          <input id="f-size" name="warehouse_size" placeholder="Approximate area or dimensions (optional)" data-testid="enquiry-warehouse-size" />
        </div>
        <div className="form-field full">
          <label htmlFor="f-msg">Message</label>
          <textarea id="f-msg" name="message" rows="4" placeholder="Tell us about what you're storing, timelines or existing systems..." data-testid="enquiry-message" />
        </div>
        <div className="form-field full">
          <label className="file-drop" data-testid="enquiry-file-drop">
            <Upload size={18} style={{ verticalAlign: "-4px", marginRight: 8 }} />
            {fileName || "Upload your warehouse layout / drawing / photograph (PDF, JPG, PNG, DWG — optional)"}
            <input type="file" name="file" accept=".png,.jpg,.jpeg,.webp,.pdf,.dwg,.dxf" onChange={(e) => setFileName(e.target.files[0]?.name || "")} data-testid="enquiry-file" />
          </label>
        </div>
      </div>
      <input type="text" name="website" className="hp-field" tabIndex="-1" autoComplete="off" aria-hidden="true" />
      <input type="hidden" name="product" value={product} />
      <button type="submit" className="btn btn-orange" style={{ width: "100%", marginTop: 22 }} disabled={loading} data-testid="enquiry-submit">
        {loading ? "Sending..." : "Submit Enquiry"} <Send size={15} />
      </button>
    </form>
  );
}
